import * as accountApi from '../services/api/account';

import { SubmissionError } from "redux-form";

export const PASSWORD_RESET_SENT = 'PASSWORD_RESET_SENT';

export function sendPasswordResetEmail(email, serviceReferrerId) {
    return dispatch => {

        let params = { email };

        if (serviceReferrerId) {
            params = {...params, service_referrer_id: serviceReferrerId};
        }

        return accountApi
            .sendPasswordReset(params)
            .then(() => dispatch(passwordResetSent(email)))
            .catch(res => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: res.payload
                });
            });
    }
}

export function passwordResetSent(resetEmailSentTo) {
    return {
        type: PASSWORD_RESET_SENT,
        resetEmailSentTo
    }
}

export function resetPassword(params) {
    return () => {
        return accountApi.resetPassword(params)
            .catch(res => {
                throw new SubmissionError({
                    ...res.payload,
                    _error: 'There was a problem resetting your password.'
                });
            });
    }
}